import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export const useCreateFeedback = () => {
  return useMutation(async (data) => {
    return await axios.post("/api/v1/feedback/create_feedback", data);
  });
};
